import React, { useState } from 'react';
import style from './RevenueSources.module.css';
import TabButtons from '../TabButtons/TabButtons';
import RevenueSourcesSegments from './RevenueSourcesSegments';
import RevenueSourcesGeographics from './RevenueSourcesGeographics';

const RevenueSources = ({ stock }) => {
  const [value, setValue] = useState(1);

  return (
    <div>
      <h3 className={style.headline}>Revenue Sources</h3>
      <TabButtons className={style.tabs}>
        <TabButtons.Tab onClick={() => setValue(1)} active={value === 1}>
          Product
        </TabButtons.Tab>
        <TabButtons.Tab onClick={() => setValue(2)} active={value === 2}>
          Country
        </TabButtons.Tab>
      </TabButtons>

      {value === 1 && (
        <RevenueSourcesSegments stock={stock} />
      )}

      {value === 2 && (
        <RevenueSourcesGeographics stock={stock} />
      )}
    </div>
  );
};

export default RevenueSources;
